import { useEffect } from "react";
import { useAppDispatch } from "@/store";
import { fetchScrapers, fetchStats } from "@/store/scrapersSlice";
import { fetchCronJobs } from "@/store/cronJobsSlice";

/** Loads scrapers, usage stats, and cron jobs for the scrapers list view. */
export function useScrapersBootstrap() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchScrapers());
    dispatch(fetchStats());
    dispatch(fetchCronJobs());
  }, [dispatch]);
}
